import type {
  Distributor,
  DistributorAllowedCampaign,
  DistributorCredentialPayload,
} from '@/types/distributors'

function normalizeAllowedCampaigns(
  value: DistributorAllowedCampaign[] | undefined
): DistributorAllowedCampaign[] {
  if (!Array.isArray(value)) {
    return []
  }

  return value.map((c) => ({
    ...c,
    commission_percent:
      c.commission_percent !== undefined && c.commission_percent !== null
        ? Number(c.commission_percent)
        : undefined,
    max_affiliate_commission_percent:
      c.max_affiliate_commission_percent !== undefined &&
      c.max_affiliate_commission_percent !== null
        ? Number(c.max_affiliate_commission_percent)
        : undefined,
  }))
}

export function normalizeDistributor(distributor: Distributor): Distributor {
  return {
    ...distributor,
    all_campaigns: distributor.all_campaigns ?? true,
    allowed_campaigns: normalizeAllowedCampaigns(distributor.allowed_campaigns),
    max_affiliate_commission_percent: Number(distributor.max_affiliate_commission_percent ?? 0),
    registrations_count: Number(distributor.registrations_count ?? 0),
  }
}

export function normalizeDistributorCredential(
  distributor: DistributorCredentialPayload
): DistributorCredentialPayload {
  return {
    ...distributor,
    all_campaigns: distributor.all_campaigns ?? true,
    allowed_campaigns: normalizeAllowedCampaigns(distributor.allowed_campaigns),
    max_affiliate_commission_percent: Number(distributor.max_affiliate_commission_percent ?? 0),
  }
}
